var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thread-list"},[_c('h2',{staticClass:"list-title"},[_vm._v("Threads")]),_vm._l((_vm.threads),function(thread){return _c('ThreadListItem',{key:thread['.key'],attrs:{"thread":thread}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }